/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEodDocumentDto } from './GetEodDocumentDto';
import {
    GetEodDocumentDtoFromJSON,
    GetEodDocumentDtoFromJSONTyped,
    GetEodDocumentDtoToJSON,
} from './GetEodDocumentDto';

/**
 * 
 * @export
 * @interface GetEodVatRegisterDto
 */
export interface GetEodVatRegisterDto {
    /**
     * 
     * @type {number}
     * @memberof GetEodVatRegisterDto
     */
    id: number;
    /**
     * 
     * @type {GetEodDocumentDto}
     * @memberof GetEodVatRegisterDto
     */
    document: GetEodDocumentDto;
    /**
     * 
     * @type {string}
     * @memberof GetEodVatRegisterDto
     */
    registerName: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodVatRegisterDto
     */
    vatRate: string;
    /**
     * 
     * @type {number}
     * @memberof GetEodVatRegisterDto
     */
    netAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetEodVatRegisterDto
     */
    vatAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetEodVatRegisterDto
     */
    grossAmount: number;
}

/**
 * Check if a given object implements the GetEodVatRegisterDto interface.
 */
export function instanceOfGetEodVatRegisterDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "document" in value;
    isInstance = isInstance && "registerName" in value;
    isInstance = isInstance && "vatRate" in value;
    isInstance = isInstance && "netAmount" in value;
    isInstance = isInstance && "vatAmount" in value;
    isInstance = isInstance && "grossAmount" in value;

    return isInstance;
}

export function GetEodVatRegisterDtoFromJSON(json: any): GetEodVatRegisterDto {
    return GetEodVatRegisterDtoFromJSONTyped(json, false);
}

export function GetEodVatRegisterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEodVatRegisterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'document': GetEodDocumentDtoFromJSON(json['document']),
        'registerName': json['registerName'],
        'vatRate': json['vatRate'],
        'netAmount': json['netAmount'],
        'vatAmount': json['vatAmount'],
        'grossAmount': json['grossAmount'],
    };
}

export function GetEodVatRegisterDtoToJSON(value?: GetEodVatRegisterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'document': GetEodDocumentDtoToJSON(value.document),
        'registerName': value.registerName,
        'vatRate': value.vatRate,
        'netAmount': value.netAmount,
        'vatAmount': value.vatAmount,
        'grossAmount': value.grossAmount,
    };
}

